import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ListingPermission from './ListingPermission';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

export default async function action({ store, intl }) {

  const title = intl?.formatMessage(messages.listingApproval);

  let isAdminAuthenticated, adminPrivileges, listingApproval;
  isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;
  adminPrivileges = store?.getState()?.adminPrevileges?.privileges && store?.getState()?.adminPrevileges?.privileges?.privileges;
  listingApproval = store?.getState()?.siteSettings?.data?.listingApproval;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  if (!restrictUrls('/siteadmin/listing-request', adminPrivileges) || listingApproval == '0') {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><ListingPermission title={title} /></AdminLayout>,
  };
}
